import SeriesResult from './SeriesResult.tsx';

export default SeriesResult;
